import ability from '@/common/ability';

export default function abilityPlugin(store) {
  store.$ability = ability;
  store.$can = function (action: string, target: string) {
    return ability.can(action, target);
  };
}
